/*
Controller: SalesReport

Operations:
  getSalesReport
  downloadSalesReport
  getSalesReportSummary
*/
var Api = require('../config')
var SalesReportRequestDef = require('../definitions/SalesReportRequest')
var SalesReportDownloadRequestDef = require('../definitions/SalesReportDownloadRequest')
var SalesReportSummaryRequestDef = require('../definitions/SalesReportSummaryRequest')

var SalesReport = (function () {
  /*
  Operation: getSalesReport
  Fetch sales report
  Parameters:
    userId: MFP User Id for whome sales report need to be fetched
    bodyRequest: Sales Report Filters
  Responses:
    HTTP 200: Success
    HTTP 400: bad Request
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 405: Method Not Allowed
    HTTP 412: SAP API Connection Issue
  */
  function getSalesReportSalesReport (userId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!userId) {
          throw new Error('userId: Missing parameter')
        }
        if (userId && !(typeof userId === 'string')) {
          throw new Error('userId: Wrong type: Got "' + (typeof userId) + '", but expected: "string"')
        }
        SalesReportRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/salesreport/{userId}'
      path = path.replace('{' + 'userId' + '}', userId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: downloadSalesReport
  Download sales report
  Parameters:
    userId: MFP User Id for whome sales report need to be fetched
    bodyRequest: Sales Report Filters
  Responses:
    HTTP 200: Success
    HTTP 400: bad Request
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 405: Method Not Allowed
    HTTP 412: SAP API Connection Issue
  */
  function downloadSalesReportSalesReport (userId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!userId) {
          throw new Error('userId: Missing parameter')
        }
        if (userId && !(typeof userId === 'string')) {
          throw new Error('userId: Wrong type: Got "' + (typeof userId) + '", but expected: "string"')
        }
        SalesReportDownloadRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/salesreport/{userId}/download'
      path = path.replace('{' + 'userId' + '}', userId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getSalesReportSummary
  Fetch sales report summary
  Parameters:
    userId: MFP User Id for whome sales report need to be fetched
    bodyRequest: Sales Report summary Filters
  Responses:
    HTTP 200: Success
    HTTP 400: bad Request
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 405: Method Not Allowed
    HTTP 412: SAP API Connection Issue
  */
  function getSalesReportSummarySalesReport (userId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!userId) {
          throw new Error('userId: Missing parameter')
        }
        if (userId && !(typeof userId === 'string')) {
          throw new Error('userId: Wrong type: Got "' + (typeof userId) + '", but expected: "string"')
        }
        SalesReportSummaryRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/salesreportsummary/{userId}'
      path = path.replace('{' + 'userId' + '}', userId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getSalesReport'] = getSalesReportSalesReport
  ret['downloadSalesReport'] = downloadSalesReportSalesReport
  ret['getSalesReportSummary'] = getSalesReportSummarySalesReport
  return ret
})()

module.exports = SalesReport
